import { render, staticRenderFns } from "./SidenavLink.vue?vue&type=template&id=2847af2a&"
import script from "./SidenavLink.vue?vue&type=script&lang=js&"
export * from "./SidenavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2847af2a')) {
      api.createRecord('2847af2a', component.options)
    } else {
      api.reload('2847af2a', component.options)
    }
    module.hot.accept("./SidenavLink.vue?vue&type=template&id=2847af2a&", function () {
      api.rerender('2847af2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/vendor/libs/sidenav/SidenavLink.vue"
export default component.exports